import { Component, Inject } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';import { CreditosListComponent } from './creditos-list.component';
import { CreditosService } from './creditos.service';

@Component({
    selector: 'convfact-creditosdelete',
    templateUrl: './creditos-dialog-delete.component.html',
    styleUrls: ['./creditos.component.css'],
    standalone: false
})
export class CreditosDialogDeleteComponent {

  public uid: string = this.data.uid;
  public response_message: string;
  public response_error: boolean;

  constructor(
    public dialogRef: MatDialogRef<CreditosListComponent>,
    public creditosService: CreditosService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public snackBar: MatSnackBar,
  ) { }

  public delete() {
    this.creditosService.delete(this.uid)
      .then(res => {
        this.response_message = "El credigo se ha eliminado correctamente";
        this.response_error = false;
      }).catch(err => {
        this.response_message = "Ha ocurrido un error al eliminar el credito";
        this.response_error = true;
      });
  }

  public closeDialog() {
    this.dialogRef.close();
  }
}
